import * as validatorMixin from "@/mixins/validatorMixin";

export default class Validator {
	/**
	 * Validator class
	 * @class Validator
	 * @param {Object} validator - Validator object
	 * @property {Boolean} valid - is valid?
	 * @property {Boolean} notValid - is not valid?
	 * @property {String} validText - outputed valid text
	 * @property {String} errText - outputed error text
	 * @property {String} constraintName - name of the constraint for the field
	 * @property {Function} validatorFunction - Validation function, must take two argument: one is the value to check, second this object to modify other properties
	 * @property {Boolean} required - is field required?
	 * @property {Boolean} isValidatorFunction - Is this validator using validator.js or use a custom function, if true use custom function. Default is false.
	 */
	constructor(validator, isValidatorFunction=false) {
		this.valid = validator.valid || false;
		this.notValid = validator.notValid || false;
		this.validText = validator.validText || null;
		this.errText = validator.errText || null;
		this.constraintName = validator.constraintName || "";
		this.validatorFunction = validator.validatorFunction || null;
		this.required = validator.required || true;
		this.isValidatorFunction = isValidatorFunction;
	}

	/**
	 * @method check Check the given value and set object properties
	 * @param {*} value
	 */
	check(value){

		if(this.isValidatorFunction){
			
			this.validatorFunction(value, this);
		}
		else{
			validatorMixin.default.methods.checkHandler(value, this);
		}
		// //console.log(value, this);
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} validator object
	 */
	static getFormFields(){
		return {
			valid: false,
			notValid: false,
			validText: null,
			errText: null,
			constraintName: "",
			required: true
		};
	}
}
